import type { MenuItem } from 'hfs-common-ui';
import React from 'react';
import MobileMenuItem from '../MobileMenuItem/MobileMenuItem';
import * as S from './styled';

export interface Props {
  activeMenuId?: number;
  menu: MenuItem[];
  onClick: (menuItem: MenuItem) => void;
  mainMenu?: boolean;
}

const MobileMenu = ({ menu, activeMenuId, onClick, mainMenu = true }: Props) => {
  return (
    <S.Nav id="mobile-menu">
      <S.NavMenu $mainMenu={mainMenu}>
        {menu.map((item) => (
          <MobileMenuItem key={item.id} menuItem={item} activeId={activeMenuId} onClick={onClick} />
        ))}
      </S.NavMenu>
    </S.Nav>
  );
};

export default MobileMenu;
